// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"c30f9e22","303":"6d8d42f9","787":"98929e5c","889":"3c11966a","964":"a2116e1f"}[chunkId] + ".chunk.js";
};